import { RouteSkeleton, type RouteSkeletonVariant } from "./RouteSkeleton";

/**
 * Drop-in <Suspense fallback={...}> element. Picks a layout-shaped skeleton
 * matching the route surface so users never see a blank screen during
 * lazy-load (or the lazyWithRetry 400ms retry window).
 */
export function RouteFallback({ variant = "marketing" }: { variant?: RouteSkeletonVariant }) {
  return <RouteSkeleton variant={variant} />;
}

export default RouteFallback;
